/**
 * Sleep for a given number of milliseconds.
 * @param ms Number of milliseconds to sleep.
 * @returns Promise that resolves after the given time.
 */
export async function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
